import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "py-3" }, "Triage Report", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, " ", -1)
const _hoisted_4 = { class: "log-col" }
const _hoisted_5 = { class: "log-col" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "log-col" }
const _hoisted_8 = { class: "log-col" }
const _hoisted_9 = { class: "log-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { style: {"max-width":"100%"} }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "primary",
                class: "mx-4 my-4",
                style: {"float":"right"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.loadData()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("REFRESH")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_data_table, {
        "data-testId": "TriageReportViewerTable",
        "group-by": $options.triageReportGroupBy(),
        headers: $options.triageReportHeaders(),
        items: _ctx.triagedRecordsData,
        "item-value": "sessionId",
        class: "elevation-1 table-striped",
        "sort-by": [{ key: 'lastReviewDate', order: 'desc' }],
        loading: _ctx.recordsLoading,
        "loading-text": "Loading... Please wait",
        page: _ctx.page,
        "items-per-page": _ctx.itemsPerPage,
        "hide-default-footer": ""
      }, {
        "group-header": _withCtx(({ item, toggleGroup, isGroupOpen }) => [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createVNode(_component_VBtn, {
                icon: isGroupOpen(item) ? '$expand' : '$next',
                size: "small",
                variant: "text",
                onClick: ($event: any) => (toggleGroup(item))
              }, null, 8, ["icon", "onClick"])
            ]),
            _createElementVNode("td", null, _toDisplayString(item.value), 1),
            _createElementVNode("td", null, _toDisplayString($options.formatTime($options.groupAggregateMax(item.items, 'sessionDate'))), 1),
            _createElementVNode("td", null, _toDisplayString($options.groupAggregateCount(item.items)), 1),
            _createElementVNode("td", null, _toDisplayString($options.groupAggregateSum(item.items, 'totalRecords')), 1),
            _createElementVNode("td", null, _toDisplayString($options.groupAggregateSum(item.items, 'totalReviews')), 1),
            _createElementVNode("td", null, _toDisplayString($options.formatDate($options.groupAggregateMax(item.items, 'lastReviewDate'))), 1)
          ])
        ]),
        item: _withCtx((props) => [
          _createElementVNode("tr", null, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("td", _hoisted_4, _toDisplayString($options.formatTime(props.item.sessionDate)), 1),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("a", {
                href: "#",
                onClick: ($event: any) => ($options.loadStudentRecord(props.item))
              }, _toDisplayString(props.item.studentId), 9, _hoisted_6)
            ]),
            _createElementVNode("td", _hoisted_7, _toDisplayString(props.item.totalRecords), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(props.item.totalReviews), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString($options.formatDate(props.item.lastReviewDate)), 1)
          ])
        ]),
        bottom: _withCtx(() => [
          _createVNode(_component_v_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { style: {"padding-top":"20px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "9" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_pagination, {
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page) = $event)),
                        length: $options.pageCount
                      }, null, 8, ["modelValue", "length"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        items: _ctx.pagingOptions,
                        label: "Page Size",
                        modelValue: _ctx.itemsPerPage,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemsPerPage) = $event)),
                        class: "mx-2",
                        variant: "underlined"
                      }, null, 8, ["items", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["group-by", "headers", "items", "loading", "page", "items-per-page"])
    ]),
    _: 1
  }))
}